<template>
  <div class="header-box">
    <div class="header-list">
      <div class="header-list-one">
        <div class="header-list-item-logo">
          <img class="header-list-item-pic" :src="logo" alt="logo" />
        </div>
        <div class="header-list-item-box">
          <div
            v-for="menuRoute in menuList"
            :key="menuRoute?.meta?.title"
            class="header-list-item header-list-item-tab"
            :class="{ ['header-list-item-active']: activePath === getPath(menuRoute) }"
            @click="openPage(menuRoute)"
          >
            {{ menuRoute?.meta?.title }}
          </div>
        </div>
      </div>
      <div class="header-list-three">
        <div class="header-list-item" @click="showManual">
          <t-icon name="course" size="16px" />
          {{ $t('操作手册') }}
        </div>
        <div v-reportclick="{ name: 'user_feedback_clck' }" class="header-list-item" @click="showDviceDialog">
          <t-icon name="edit" size="16px" />
          {{ $t('意见反馈') }}
        </div>
        <div class="header-list-item" @click="toAudit">
          <t-icon name="user-circle" size="16px" />
          <t-badge v-if="isBusinessOrAdmin" :count="userTodo.review_count" size="small" show-zero>
            <span>{{ userInfo.name }}</span>
          </t-badge>
          <span v-else>{{ userInfo.name }}</span>
        </div>
        <div class="header-list-item" @click="handleLogout">
          <t-icon name="logout" size="16px" />
          {{ $t('退出登录') }}
        </div>
        <!-- <t-dropdown :max-column-width="300" :min-column-width="100" trigger="hover" placement="bottom-right">
          <template #dropdown>
            <t-dropdown-menu>
              <t-dropdown-item class="w-full flex items-center" @click="handleLogout">
                <t-icon name="poweroff"></t-icon>
                {{ $t('退出登录') }}
              </t-dropdown-item>
            </t-dropdown-menu>
          </template>
          <div class="header-list-avatar">
            <t-avatar
              v-report="{ name: 'user_cnt' }"
              class="header-user-btn"
              hide-on-load-failed
              :icon="defaultUserIcon"
            />
            <t-icon class="ml-10" name="caret-down-small" />
          </div>
        </t-dropdown>
        <div class="flex items-center text-black">
          <span>{{ userInfo.name }}</span>
          <t-link v-if="isBusinessOrAdmin" theme="primary" hover="color" @click="toAudit">
            （{{ userTodo.review_count }}）
          </t-link>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script setup lang="tsx">
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { usePermissionStore, useUserStore, type UserInfo } from '@/store';
// import { UserIcon } from 'tdesign-icons-vue-next';
import logo from '@/assets/layout/login-logo.png';
import { type MenuRoute } from '@tencent/iegsp-common/tools/utils/route';
import { reportEvent, ReportEventName } from '@/utils/galileo';

// 高级设置
const { menuRoutes } = storeToRefs(usePermissionStore());
const { userTodo, isBusinessOrAdmin } = storeToRefs(useUserStore());

defineProps<{
  userInfo: UserInfo;
}>();

const router = useRouter();
const route = useRoute();

const menuList = computed(() => {
  if (route?.query?.recommend_supplier === '1') {
    return menuRoutes.value.filter((item) => !(item.meta as any)?.iframeHidden);
  }
  return menuRoutes.value;
});

const activePath = computed(() => {
  //详情页激活态处理
  if (/^\/((learning\/index)|index|dashboard\/base)(\/.*)?$/.test(route?.path)) {
    return '/index';
  }
  return route?.path;
});

// const defaultUserIcon = computed(() => () => <UserIcon size="20px" />);

const getPath = (item: MenuRoute) => item.path || item.children?.[0].path;

const openPage = (menuRoute: MenuRoute) => {
  router.push(getPath(menuRoute));
};

const showDviceDialog = () => {
  const url = 'https://doc.weixin.qq.com/forms/AJEAIQdfAAoAAwAzAbdAFwCN6Mu6zihDf';
  reportEvent(ReportEventName.FeedbackClick, { url, page: 'Index' });
  window.open(url, '_blank');
};
const showManual = () => {
  const url = 'https://doc.weixin.qq.com/slide/p3_AaMAAQapAMQCNqKEISrY1Q7Off517?scode=AJEAIQdfAAoFC5TzNSAbcA3AbsAKc';
  reportEvent(ReportEventName.GuidelinesClick, { url });
  window.open(url, '_blank');
};
const handleLogout = () => {
  useUserStore()
    .logout()
    .then(() => {
      router.push('/login');
    });
};

const toAudit = () => {
  if (!isBusinessOrAdmin.value) return;
  router.push('/userReview/index');
};
</script>
<style lang="less" src="./css/header.less" scoped></style>
